// import moment from 'moment'
export default {
  methods: {
    _deleteEticket (eticketId) {
      return this.$http.delete('user/deletestoredeticket', this.completeHttpParams({ headers: { eticketId }, emulateJSON: false })).then(response => response.body)
    },
    _userValidateEticket (eticketId, validate) {
      return this.$http.get('user/uservalidatestoredeticket', this.completeHttpParams({ params: { eticketId, validate: '' + validate }, emulateJSON: false }), this.completeHttpParams({ emulateJSON: false })).then(response =>  response.body)
    },
    _getEtickets (lastEticketId) {
      return this.$http.get('user/storedetickets', this.completeHttpParams({ headers: { lastEticketId }, params: { complete: 'true' }, emulateJSON: false })).then(response => response.body)
    },
    _updateValidations (ids) {
      return this.$http.post('sales/validationstatus', ids, this.completeHttpParams({ emulateJSON: false })).then(response => response.body)
    }
  }
}